// queries/useGetLoras.ts
"use client";

import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_LORAS, GET_FLUX_LORAS } from "api";

interface Lora {
  name: string;
  title: string;
  alias?: string;
  path?: string;
  image_url: string;
  is_nsfw: boolean;
  metadata?: {
    [key: string]: any;
    ss_output_name?: string;
  };
  trigger_words?: string;
  default_scale?: number; 
}

interface LoraResponse {
  loras: Lora[];
  total: number;
}

interface GetLorasOptions {
  isFlux?: boolean;
  nsfwFilter?: boolean;
}

const fetchLoras = async ({ isFlux, nsfwFilter }: GetLorasOptions): Promise<LoraResponse> => {
  const endpoint = isFlux ? GET_FLUX_LORAS : GET_LORAS;
  const url = nsfwFilter !== undefined 
    ? `${endpoint}?nsfw_filter=${nsfwFilter}`
    : endpoint;
    
  return fetch(url);
};

export const useGetLoras = (options: GetLorasOptions = {}) => {
  const { isFlux = false, nsfwFilter } = options;

  return useQuery<LoraResponse, Error>({
    queryKey: ["loras", options],
    queryFn: () => fetchLoras(options),
  });
};

export default useGetLoras;